<template>
    <div
        :class="[
            gap,
            containerPadding,
            containerRounded,
            verticalOnMobile ? 'flex-col md:flex-row' : 'flex-row',
            'w-fit shadow-inner self-center bg-sidebar border-2 flex relative z-0',
        ]"
        ref="tabs-container"
    >
        <span
            ref="animated-tab-button"
            :class="[
                animate ? ['transition-all', duration] : '',
                buttonRounded,
                ' absolute z-1 bg-sidebar-locale-active',
            ]"
        ></span>
        <button
            v-for="(tab, index) in tabs"
            :key="tab.slug"
            @click="tabClicked(tab.slug, index)"
            :class="[
                activeTabSlug == tab.slug
                    ? ' text-white '
                    : 'text-text-secondary hover:text-gray-900',
                duration,
                buttonPadding,
                buttonRounded,
                'flex items-center justify-center gap-x-1.5 leading-4 font-medium focus:outline-none transition duration-200 z-5',
            ]"
        >
            <component
                v-if="isComponent(tab.icon)"
                :is="tab.icon"
                :class="[iconClass]"
            />
            <div v-else v-html="tab.icon" />
            <p v-if="tab.text" v-text="tab.text" />
        </button>
    </div>
    <!-- <div class="flex items-center">
    </div> -->
</template>

<script>
/*
 * Array of tabs
 * {
 * 	 slug: String,
 * 	 icon: HTML,
 * 	 title: String,
 * }
 */
export default {
    emit: ['TabClicked'],

    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
        activeTabSlug: {
            type: String,
            default: null,
        },
        animate: { default: true },
        gap: { default: 'gap-x-1' },
        containerPadding: { default: 'p-1' },
        buttonPadding: { default: 'px-3 py-2.5' },
        containerRounded: { default: 'rounded-lg' },
        buttonRounded: { default: 'rounded-lg' },
        duration: { default: 'duration-300' },
        iconClass: { default: 'h-6 w-6' },
        verticalOnMobile: { default: true },
    },

    mounted() {
        this.addContainerHeightListener()
        this.animateToActiveTab()
    },

    beforeUnmount() {
        if (this.heightObserver && this.$refs['tabs-container']) {
            this.heightObserver.disconnect()
        }
    },

    watch: {
        'tabs.length'() {
            this.animateToActiveTab()
        },

        activeTabSlug() {
            this.animateToActiveTab()
        },
    },

    methods: {
        tabClicked(slug, index) {
            if (this.activeTabSlug != slug) {
                this.$emit('TabClicked', slug)
            }
        },

        animateToTab(index) {
            let container = this.$refs['tabs-container']
            let animatedTab = this.$refs['animated-tab-button']
            if (container) {
                let child = [...container.children][index + 1]

                animatedTab.style.width = child.offsetWidth + 'px'
                animatedTab.style.height = child.offsetHeight + 'px'
                animatedTab.style.left = child.offsetLeft + 'px'
                animatedTab.style.top = child.offsetTop + 'px'
            }
        },

        getIndexOfTab(slug) {
            return this.tabs.findIndex((t) => t.slug == slug)
        },

        animateToActiveTab() {
            let index = this.getIndexOfTab(this.activeTabSlug)
            if (index >= 0) {
                this.animateToTab(index)
            }
        },

        addContainerHeightListener() {
            this.heightObserver = new ResizeObserver(this.animateToActiveTab)
            this.heightObserver.observe(this.$refs['tabs-container'])
        },

        isComponent(icon) {
            return (
                icon &&
                (typeof icon.render === 'function' ||
                    typeof icon.setup === 'function')
            )
            return typeof icon === 'object'
        },
    },
}
</script>
